Shopware.Component.register('riccardo-search-terms', () => import('./page/riccardo-search-terms'));
Shopware.Component.register('riccardo-search-synonyms', () => import('./page/riccardo-search-synonyms'));
Shopware.Component.register('riccardo-search-rules', () => import('./page/riccardo-search-rules'));

Shopware.Module.register('riccardo-search', {
    type: 'plugin',
    name: 'riccardo-search',
    title: 'Suche',
    description: 'Suchbegriffe auswerten, Synonyme pflegen, Treffer steuern',
    color: '#E30613',
    icon: 'regular-search',

    routes: {
        terms: { component: 'riccardo-search-terms', path: 'begriffe' },
        synonyms: { component: 'riccardo-search-synonyms', path: 'synonyme' },
        rules: { component: 'riccardo-search-rules', path: 'regeln' },
    },

    navigation: [
        {
            id: 'riccardo-search',
            label: 'Suche',
            color: '#E30613',
            path: 'riccardo.search.terms',
            icon: 'regular-search',
            parent: 'sw-content',
            position: 92,
        },
    ],
});
